/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ActionsInputs */

const en_actions = /** @type {(inputs: ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const fr_actions = /** @type {(inputs: ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const de_actions = /** @type {(inputs: ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

const it_actions = /** @type {(inputs: ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni`)
};

const ru_actions = /** @type {(inputs: ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действия`)
};

const es_actions = /** @type {(inputs: ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comportamiento`)
};

const zh_cn2_actions = /** @type {(inputs: ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行动`)
};

const ja_actions = /** @type {(inputs: ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクション`)
};

const hi_actions = /** @type {(inputs: ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्रवाई`)
};

const pt_pt2_actions = /** @type {(inputs: ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {ActionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const actions = /** @type {((inputs?: ActionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ActionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_actions(inputs)
	if (locale === "de") return de_actions(inputs)
	if (locale === "it") return it_actions(inputs)
	if (locale === "ru") return ru_actions(inputs)
	if (locale === "es") return es_actions(inputs)
	if (locale === "zh-CN") return zh_cn2_actions(inputs)
	if (locale === "ja") return ja_actions(inputs)
	if (locale === "hi") return hi_actions(inputs)
	if (locale === "pt-PT") return pt_pt2_actions(inputs)
	return en_actions(inputs)
});